export const SKILLS = [
  {
    name: "Programming Languages",
    items: ["Java", "Python", "Go"],
    // logos: ["java.png", "python.png", "go.png"],
    logos: ["java.png"],
  },
  {
    name: "Web Design and Development",
    items: ["HTML", "CSS", "Bootstrap", "JavaScript"],
    // logos: ["html.png", "css.png", "bootstrap.png", "javascript.png"],
    logos: ["javascript.png"],
  },
  {
    name: "Frontend Frameworks",
    items: ["React", "Angular"],
    // logos: ["react.png", "angular.png"],
    logos: ["react.png"],
  },
  {
    name: "Backend Frameworks",
    items: ["Flask", "Spring Boot"],
    // logos: ["flask.png", "springboot.png"],
    logos: ["springboot.png"],
  },
  {
    name: "Database & Caching",
    items: ["MongoDB", "MySQL", "Redis"],
    // logos: ["mongo.png", "mysql.png", "redis.png"],
    logos: ["mongo.png"],
  },
  {
    name: "Tools",
    items: ["Git", "Figma"],
    // logos: ["git.png", "figma.png"],
    logos: ["git.png"],
  },
];
